/**
 * @fileoverview GET handler for the "/apps/user_info/get_click_through_tracking_config" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoGetClickThroughTrackingConfig } from "./constants";
import type { AppsUserInfoGetClickThroughTrackingConfigResult } from "./types";
import { isAppsUserInfoGetClickThroughTrackingConfigResult } from "./validators";

export const getAppsUserInfoGetClickThroughTrackingConfig = reactQueryFetcherAdapter(
  appsUserInfoGetClickThroughTrackingConfig,
  (signal: AbortSignal): Promise<AppsUserInfoGetClickThroughTrackingConfigResult> => {
    return fetch("/apps/user_info/get_click_through_tracking_config", "GET", {}, { signal });
  },
  isAppsUserInfoGetClickThroughTrackingConfigResult
);
